import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { GenericFilter } from './generic_filter';
import { PriceFilter as PriceFilterInput } from '../../components/search_filters/filters/price_filter';
import { setFromPrice,
          setToPrice,
          setPriceCurrency,
          setPriceType,
          setDirty,
          initialState } from '../../redux/modules/search/price';

import { ISearchPrice } from '../../models/filters/price';

interface IProps {
  price: ISearchPrice;
  dispatch: Dispatch<any>;
}

class PriceFilter extends GenericFilter<IProps> {
  protected setDirty(isDirty: boolean) {
    this.props.dispatch(setDirty(isDirty));
  }

  public componentWillMount() {
    this.props.dispatch(setPriceCurrency(initialState.currency));
    this.props.dispatch(setPriceType(initialState.priceType));
  }

  public render() {
    return (
      <PriceFilterInput
        fromPrice={this.props.price.fromPrice}
        toPrice={this.props.price.toPrice}

        onChangeFromPrice={(value: number) => this.props.dispatch(setFromPrice(value))}
        onChangeToPrice={(value: number) => this.props.dispatch(setToPrice(value))}
        />
      );
  }
}

class CommercialPriceFilter extends React.Component<IProps> {
  public render() {
    return (
      <PriceFilterInput
        fromPrice={this.props.price.fromPrice}
        toPrice={this.props.price.toPrice}
        currency={this.props.price.currency}
        priceType={this.props.price.priceType}
        priceTypes={[
          {value: 'all', label: 'за все'},
          {value: 'meters', label: 'за м²'},
        ]}

        onChangeFromPrice={(value: number) => this.props.dispatch(setFromPrice(value))}
        onChangeToPrice={(value: number) => this.props.dispatch(setToPrice(value))}
        onChangeCurrency={(value: string) => this.props.dispatch(setPriceCurrency(value))}
        onChangePriceType={(value: string) => this.props.dispatch(setPriceType(value))}
        />
      );
  }
}

class CommercialRentPriceFilter extends React.Component<IProps> {
  public render() {
    return (
      <PriceFilterInput
        fromPrice={this.props.price.fromPrice}
        toPrice={this.props.price.toPrice}
        currency={this.props.price.currency}
        priceType={this.props.price.priceType}
        priceTypes={[
          {value: 'all', label: 'за месяц'},
          {value: 'meters', label: 'за м² в год'},
        ]}

        onChangeFromPrice={(value: number) => this.props.dispatch(setFromPrice(value))}
        onChangeToPrice={(value: number) => this.props.dispatch(setToPrice(value))}
        onChangeCurrency={(value: string) => this.props.dispatch(setPriceCurrency(value))}
        onChangePriceType={(value: string) => this.props.dispatch(setPriceType(value))}
        />
      );
  }
}

const PriceFilterWrapper = connect((state: { price: ISearchPrice }) => ({
  price: state.price,
}))(PriceFilter as any);

const CommercialPriceFilterWrapper = connect((state: { price: ISearchPrice }) => ({
  price: state.price,
}))(CommercialPriceFilter);

const CommercialRentPriceFilterWrapper = connect((state: { price: ISearchPrice }) => ({
  price: state.price,
}))(CommercialRentPriceFilter);

export {
  PriceFilterWrapper as PriceFilter,
  PriceFilter as PriceFilterClass,
  CommercialPriceFilterWrapper as CommercialPriceFilter,
  CommercialPriceFilter as CommercialPriceFilterClass,
  CommercialRentPriceFilterWrapper as CommercialRentPriceFilter,
  CommercialRentPriceFilter as CommercialRentPriceFilterClass,
};
